import { useNavigate } from 'react-router-dom';

export default function ServiceCard({ service }) {
  const navigate = useNavigate();

  return (
    <div className="service-card bg-white p-8 rounded-lg shadow-md transition duration-300">
      <div className="text-blue-600 text-4xl mb-6">
        <i className={`fas fa-${service.icon}`}></i>
      </div>
      <h3 className="text-xl font-bold text-gray-800 mb-4">{service.title}</h3>
      <p className="text-gray-600 mb-6">{service.description}</p>
      <button 
        onClick={() => navigate('/quote', { state: { service } })} 
        className="text-blue-600 hover:text-blue-700 font-medium flex items-center"
      >
        Get a Quote <i className="fas fa-arrow-right ml-2"></i>
      </button>
    </div>
  );
}
